// A diagnostic ticket is renamed by the server once its report is finished (symptom +
// most likely cause). Every place that requests a report announces the new title so the
// conversation sidebar updates without a reload; Garage and Glove Box read titles fresh
// from the server each time they open.
export const TICKET_TITLE_CHANGED_EVENT = 'dash_ticket_title_changed';

export function announceTicketTitle(threadId, reportResponse) {
    const title = String(reportResponse?.ticket_title || '').trim();
    if (!threadId || !title || typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(TICKET_TITLE_CHANGED_EVENT, {
        detail: { threadId: String(threadId), title },
    }));
}
